/* eslint-disable-next-line no-unused-vars -- motion.div used in JSX (member expression not tracked by no-unused-vars) */
import { motion } from "framer-motion";

export default function PageTransition({ children, pathname }) {
  const isAuthPage = pathname === "/login" || pathname === "/register";
  if (isAuthPage) return <>{children}</>;
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
